export const taxRate = 0.04;
